interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  type?: string;
}

export default function Seo({ title, description, keywords, path = '/', type = 'website' }: SeoProps) {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const canonical = `${origin}${path}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </>
  );
}